import { AppSidebar } from "@/components/AppSidebar"
import { Header, type HeaderProps } from "@/components/Header"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"

import "@/index.css"
import type React from "react"
import { useLocation } from "react-router-dom"

export function Dashboard(props: React.PropsWithChildren<HeaderProps>) {
  const { pathname } = useLocation();
  const pagesNames: Record<string, string> = {
    "/classes": "Classes",
    "/bookings": "Bookings",
  };
  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "calc(var(--spacing) * 72)",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" />
      <SidebarInset>
        <Header pageName={pagesNames[pathname]!} />
        <div className="flex flex-1 flex-col p-4">
          {props.children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
